(function () {
  const SEEN_KEY = "purity_welcome_seen";
  if (sessionStorage.getItem(SEEN_KEY)) return;

  const popupImage = window.PURITY_WELCOME_POPUP_IMAGE || "";
  const DISCOUNT_CODE = "PURITY15";

  const wrap = document.createElement("div");
  wrap.className = "welcome-popup";
  wrap.innerHTML = `
    <div class="welcome-popup__card" role="dialog" aria-modal="true" aria-label="Offre de bienvenue">
      <button type="button" class="welcome-popup__close" aria-label="Fermer">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </button>
      ${popupImage ? `<div class="welcome-popup__media"><img src="${popupImage}" alt=""></div>` : ""}
      <div class="welcome-popup__content">
        <span class="welcome-popup__eyebrow">Bienvenue chez Purity</span>
        <h2 class="welcome-popup__title">15% de rabais</h2>
        <p class="welcome-popup__body">Inscris-toi à la liste privée et débloque ta remise instantanée sur ta première commande.</p>
        <form class="welcome-popup__form" novalidate>
          <label class="sr-only" for="welcome-email">Adresse e-mail</label>
          <input id="welcome-email" type="email" placeholder="Adresse e-mail" required autocomplete="email">
          <button type="submit">Réclamer la réduction</button>
        </form>
        <button type="button" class="welcome-popup__dismiss">Non merci</button>
      </div>
    </div>
  `;
  document.body.appendChild(wrap);

  function close() {
    wrap.classList.remove("is-open");
    sessionStorage.setItem(SEEN_KEY, "1");
  }

  wrap.querySelector(".welcome-popup__close").addEventListener("click", close);
  wrap.querySelector(".welcome-popup__dismiss").addEventListener("click", close);
  wrap.addEventListener("click", (e) => { if (e.target === wrap) close(); });

  wrap.querySelector(".welcome-popup__form").addEventListener("submit", (e) => {
    e.preventDefault();
    const email = document.getElementById("welcome-email").value.trim();
    const submitBtn = wrap.querySelector(".welcome-popup__form button[type=submit]");
    submitBtn.disabled = true;

    const body = new URLSearchParams({
      form_type: "customer",
      utf8: "✓",
      "contact[email]": email,
      "contact[tags]": "newsletter,welcome-popup"
    });

    fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString()
    }).finally(() => {
      wrap.querySelector(".welcome-popup__title").textContent = "Merci !";
      wrap.querySelector(".welcome-popup__body").innerHTML = `Utilise ce code à la caisse :<br><span class="welcome-popup__code" id="welcome-code">${DISCOUNT_CODE}</span>`;
      wrap.querySelector(".welcome-popup__form").style.display = "none";

      const codeEl = document.getElementById("welcome-code");
      codeEl.addEventListener("click", () => {
        navigator.clipboard.writeText(DISCOUNT_CODE).then(() => {
          const original = codeEl.textContent;
          codeEl.textContent = "Copié !";
          setTimeout(() => (codeEl.textContent = original), 1200);
        });
      });
    });
  });

  setTimeout(() => wrap.classList.add("is-open"), 900);
})();
